import { render, staticRenderFns } from "./postNew.vue?vue&type=template&id=5e381540"
import script from "./postNew.vue?vue&type=script&lang=js"
export * from "./postNew.vue?vue&type=script&lang=js"
import style0 from "./postNew.vue?vue&type=style&index=0&id=5e381540&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports